import { doRequest } from '@r1-frontend/do-request/index';
import { checkPassport, IResponseDto } from '@r1-frontend/api-domru/core-profile/api/v1/user/checkPassport';

import { checkNewEnter } from '~/src/features/lk/PassportUpdate/helpers/checkNewEnter';
import { initialized } from '~/src/features/lk/PassportUpdate/store/actions';
import { TAppThunkDispatch } from '~/src/store';

/**
 * Проверяем необходимость обновления персональных данных
 */
export const initialize = () => async(dispatch: TAppThunkDispatch): Promise<void> => {
    const response = await doRequest.coreProfile<IResponseDto>(checkPassport());

    if (response.isSuccess) {
        const isNewEnter = checkNewEnter();

        dispatch(initialized(response.payload.isActualData, isNewEnter));
    }
};
